import { Ref, Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CollectionRating extends ThemeComponent {

    init() {

    }
}
